// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"1034e337","453":"b5d3b766","934":"2c7a1ff5"}[chunkId] + ".chunk.js";
};